import styled from 'styled-components';
import { COLOR_BLACK, COLOR_WHITE, COLOR_RED } from '../../../assets/styles/colors';

const inputBase = `
  display: block;
  width: 100%;
  outline: none;
  border: none;
  padding-left: 16px;
  padding-right: 16px;
  height: 50px;
  font-size: 18px;
  -moz-appearance: none;
-webkit-appearance: none;
`;

export const Label = styled.label`
  font-size: 12px;
  line-height: 1.25;
  margin-bottom: 8px;
`;

export const InputCopySC = styled.div`
  position: relative;

  input {
    ${inputBase}
    padding-right: 168px;
    background: #f3f4f5;
    border: 1px solid #dbdde1;
  }

  button {
    position: absolute;
    top: 50%;
    right: 9px;
    transform: translateY(-50%);
  }
`;

export const InputGroupSC = styled.div`
  position: relative;
  label {
    margin-bottom: 6px;
    font-size: 12px;
    font-weight: 600;
    color: ${COLOR_BLACK};
    line-height: 1.5;
  }

  input {
    ${inputBase}

    border-radius: 2px;
    min-width: 100%;
    width: 100%;
    padding: 12px 15px;
    border: 1px solid rgba(63, 61, 86, 0.4);
    background-color: ${COLOR_WHITE};
    font-size: 18px;
    line-height: 24px;
    border-radius: 12px;
    -webkit-appearance: none;

    &:read-only {
      opacity: 0.5;
      &:hover,
      &:focus {
        opacity: 0.5;
        border: 1px solid rgba(63, 61, 86, 0.4);
        outline: none;
        box-shadow: none;
      }
    }

    &::placeholder {
      color: #3f3d56;
      opacity: 0.3;
      font-weight: 400;
    }

    &:focus,
    &:hover {
      border: 1px solid #000000;
      outline: none;
      box-shadow: none;
      ${({ hasError }) => (hasError ? `border-color: ${COLOR_RED};` : 'border-color: #000000;')}
    }
  }
`;
